<template>
    <div v-if="isNipEmployee" class="mb-3" :class="sizeClassObject">
        <div class="card border-secondary h-100">
            <div class="card-header pb-0">
                <div class="btn-toolbar justify-content-between" role="toolbar">
                    <div>
                        <h5>
                            <i class="fas fa-bookmark"></i>
                            {{ $t('otherActivities') }}
                        </h5>
                    </div>
                    <div>
                        <h5>
                            <button v-if="expanded" class="btn btn-link" @click.stop="sizeToggle">
                                <i class="fas fa-compress-arrows-alt"></i>
                            </button>
                            <button v-else class="btn btn-link" @click.stop="sizeToggle">
                                <i class="fas fa-expand-arrows-alt"></i>
                            </button>
                        </h5>
                    </div>
                </div>
            </div>
            <div class="card-body">
                <div class="card-deck">
                    <unfinished-tasks />
                    <unfinished-signing />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import UnfinishedTasks from '@/components/dynamic/statuses/UnfinishedTasks';
    import UnfinishedSigning from '@/components/dynamic/statuses/UnfinishedSigning';
    import { DynamicLayoutPageSize } from '@/models/enums';
    import { mapGetters } from 'vuex';

    export default {
        props: {
            size: Number
        },
        components: {
            UnfinishedTasks,
            UnfinishedSigning
        },
        data() {
            return {
                expanded: this.size === 12,
            }
        },
        computed: {
            ...mapGetters(['claims']),
            isNipEmployee() {
                // return this.$store.getters.userRoles.includes(Role.Nip);
                return this.$store.getters.claims.nijEmployee.read;
            },
            sizeClassObject() {
                return this.$helpers.sizeClassObject(this.expanded ? DynamicLayoutPageSize.Max : Math.min(this.size, 6));
            },
        },
        methods: {
            sizeToggle() {
                this.expanded = !this.expanded;
            },
        }
    }
</script>
